import { useEffect } from "react";
import SqftStore from "../../canvas/store/sqftStore";

const useDebugOverlay = (enabled) => {
  useEffect(() => {
    if (!enabled) return;

    let overlay = document.getElementById("debug-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "debug-overlay";
      overlay.style.position = "fixed";
      overlay.style.top = "21px";
      overlay.style.right = "10px";
      overlay.style.background = "rgba(0,0,0,0.8)";
      overlay.style.color = "white";
      overlay.style.padding = "10px";
      overlay.style.fontSize = "14px";
      overlay.style.zIndex = "10000";
      overlay.style.borderRadius = "5px";
      overlay.style.pointerEvents = "none";
      document.body.appendChild(overlay);
    }

    let lastTime = performance.now();
    let frameCount = 0;
    let renderCalls = 0;
    let activeTimers = 0;
    let animationFrameId = null;

    const viewGL = SqftStore.viewGL;
    if (viewGL && viewGL.renderer) {
      const originalRender = viewGL.renderer.render;
      viewGL.renderer.render = function (...args) {
        renderCalls++;
        return originalRender.apply(this, args);
      };
    }

    const originalSetTimeout = window.setTimeout;
    window.setTimeout = function (...args) {
      activeTimers++;
      const timeoutId = originalSetTimeout.apply(this, args);
      setTimeout(() => {
        activeTimers--;
      }, 0);
      return timeoutId;
    };

    const updateDebugOverlay = () => {
      const now = performance.now();
      frameCount++;

      if (now - lastTime >= 1000) {
        let totalMeshes = 0;
        let totalTextures = 0;
        let totalGeometries = 0;
        let totalMemory = "N/A";

        console.log("viewGL", viewGL);
        if (viewGL && viewGL.scene) {
          viewGL.scene.traverse((node) => {
            if (node.isMesh) totalMeshes++;
            if (node.isMesh && node.material && node.material.map) totalTextures++;
            if (node.isMesh && node.geometry) totalGeometries++;
          });

          const gl = viewGL && viewGL.renderer ? viewGL.renderer.getContext() : null;
          if (gl) {
            totalMemory = (gl.getParameter(gl.MAX_RENDERBUFFER_SIZE) / (1024 * 1024)).toFixed(2);
          }
        }

        let jsHeapSize = "N/A";
        if (performance.memory && performance.memory.usedJSHeapSize) {
          jsHeapSize = (performance.memory.usedJSHeapSize / 1024 / 1024).toFixed(2);
        }

        overlay.innerHTML = `
          🚀 <b>iPhone Debug Monitor</b><br>
          🎯 FPS: ${frameCount}<br>
          📦 Meshes: ${totalMeshes}<br>
          🖼 Textures: ${totalTextures}<br>
          📐 Geometries: ${totalGeometries}<br>
          🧠 GPU VRAM: ${totalMemory} MB<br>
          💾 JS Heap: ${jsHeapSize} MB<br>
          🔄 Render Calls/sec: ${renderCalls}<br>
          ⏳ Active Timers: ${activeTimers}<br>
        `;

        frameCount = 0;
        renderCalls = 0;
        lastTime = now;
      }

      animationFrameId = requestAnimationFrame(updateDebugOverlay);
    };

    animationFrameId = requestAnimationFrame(updateDebugOverlay);

    // ✅ Ловим ошибки в WebGL и JS
    window.onerror = function (message) {
      overlay.innerHTML += `<br>🚨 WebKit Error: ${message}`;
    };

    return () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      if (overlay) overlay.remove();
      window.onerror = null;
    };
  }, [enabled]);
};

export default useDebugOverlay;
